import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { ApplicationConfig } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withEnabledBlockingInitialNavigation, withInMemoryScrolling } from '@angular/router';
import Aura from '@primeng/themes/aura';
import { definePreset } from '@primeng/themes';
import { providePrimeNG } from 'primeng/config';
import { OLDELVAL_BRAND_BLUE, buildBrandPresetExtension } from './app/core/theme/oldelval-brand-palettes';

const OldelvalPreset = definePreset(Aura, buildBrandPresetExtension(OLDELVAL_BRAND_BLUE));
import { MessageService, ConfirmationService } from 'primeng/api';
import { appRoutes } from './app.routes';
import { AuthInterceptor, ContextHeaderInterceptor } from './app/core';

export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(appRoutes, withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' }), withEnabledBlockingInitialNavigation()),
        provideHttpClient(withFetch(), withInterceptors([ContextHeaderInterceptor, AuthInterceptor])),
        provideAnimationsAsync(),
    providePrimeNG({
            theme: { preset: OldelvalPreset, options: { darkModeSelector: '.app-dark' } },
            translation: {
                monthNames: ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'],
                dayNames: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
                dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
                dayNamesMin: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá'],
                monthNamesShort: ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic'],
                today: 'Hoy',
                clear: 'Limpiar',
                apply: 'Aplicar',
                accept: 'Sí',
                reject: 'No',
                cancel: 'Cancelar',
                weekHeader: 'Sem',
                emptyMessage: 'Sin opciones disponibles',
                emptyFilterMessage: 'Sin resultados',
                emptySearchMessage: 'Sin resultados',
                emptySelectionMessage: 'Sin selección',
                searchMessage: '{0} resultados disponibles',
                selectionMessage: '{0} seleccionados',
                chooseDate: 'Elegir fecha',
                chooseMonth: 'Elegir mes',
                chooseYear: 'Elegir año',
                prevMonth: 'Mes anterior',
                nextMonth: 'Mes siguiente',
                prevYear: 'Año anterior',
                nextYear: 'Año siguiente',
                prevDecade: 'Década anterior',
                nextDecade: 'Década siguiente',
                prevHour: 'Hora anterior',
                nextHour: 'Hora siguiente',
                prevMinute: 'Minuto anterior',
                nextMinute: 'Minuto siguiente',
            }
    }),
    MessageService,
    ConfirmationService
    ]
};
